import { Component, Inject, NgModule } from '@angular/core';
import { A11yModule } from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';
import { BehaviorSubject, of, map, switchMap } from 'rxjs';
import { MatDialogModule, MAT_DIALOG_DATA, MatDialogClose } from '@angular/material/dialog';
import { MatIconModule, MatIcon } from '@angular/material/icon';
import { MatButtonModule, MatIconButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { EmailMgmtService } from '@uw/core/services/email-mgmt.service';
import { SafeHtmlPipe } from '../../pipes/safe-html.pipe';


@Component({
    selector: 'uw-campaign-email-preview-dialog',
    templateUrl: './campaign-email-preview-dialog.component.html',
    styleUrls: ['./campaign-email-preview-dialog.component.scss'],
    imports: [A11yModule, MatIconButton, MatDialogClose, MatIcon, TranslateModule, SafeHtmlPipe]
})
export class CampaignEmailPreviewDialogComponent {

  private readonly _campaingEmailId: BehaviorSubject<any> = new BehaviorSubject(null);
  body: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) _data: any,
    private readonly _emailMgmtService: EmailMgmtService
  ) {
    this.body = _data.body;
  }
}

@NgModule({
    exports: [
        CampaignEmailPreviewDialogComponent
    ],
    imports: [
        A11yModule,
        CommonModule,
        MatDialogModule,
        MatIconModule,
        MatButtonModule,
        TranslateModule,
        CampaignEmailPreviewDialogComponent
    ]
})
export class CampaignEmailPreviewDialogModule { }
